"use strict";

export default class ModalController {
  /*@ngInject*/
  constructor(
    $uibModalInstance,
    stripe,
    title,
    text,
    application,
    Applications
  ) {
    this._Applications = Applications;
    this.payment = {};
    this._stripe = stripe;
    this._$uibModalInstance = $uibModalInstance;
    this.application = application;
    this.title = title;
    this.text = text;
    this.data = {};
    this.error = null;
  }

  ok() {
    this._$uibModalInstance.close(this.data);
  }

  acceptApp(data) {
    this._Applications
      .capture(data)
      .then((response) => {
        this.error = null;
        this._$uibModalInstance.close(response);
      })
      .catch((err) => {
        console.log(err);
        this.error = err.data.message;
      });
  }

  waitApp(data) {
    console.log(data);
    data.newStatus = "Wait List";
    this._Applications
      .refund(data)
      .then((response) => {
        this.error = null;
        this._$uibModalInstance.close(response);
      })
      .catch((err) => {
        console.log(err);
        this.error = err.data.message;
      });
  }

  cancel() {
    this._$uibModalInstance.dismiss("cancel");
  }

  getToken() {
    console.log("Stripe Token Test");
    this._stripe.card
      .createToken(this.payment)
      .then((response) => {
        console.log(response);
        this.error = null;
        //  console.log('token created for card ending in ', response.card.last4);
        //  var payment = angular.copy(this.payment);
        this.payment.number = void 0;
        this.payment.cvc = void 0;
        this.payment.exp_month = void 0;
        this.payment.exp_year = void 0;
        this.payment.token = response.id;
        //  console.log(response);
        //  console.log(this.payment);

        this.application.ip = response.client_ip;

        this.application.charge = {
          token: response.id,
          cardholder: response.card.name,
          billing: {
            line1: response.card.address_line1,
            line2: response.card.address_line2,
            city: response.card.address_city,
            state: response.card.address_state,
            zip: response.card.address_zip,
          },
          cardId: response.card.id,
          last4: response.card.last4,
          brand: response.card.brand,
        };

        //  return this._Applications.payAndAccept(this.application);
        return this._$uibModalInstance.close(this.application);
      })
      //  .then(result => {
      //    console.log(result);
      //    this._$uibModalInstance.close(result);
      //  })
      .catch((err) => {
        if (err.type && /^Stripe/.test(err.type)) {
          console.log("Stripe error: ", err.message);
          this.error = err.message;
        } else {
          console.log(
            "Other error occurred, possibly with your API",
            err.message
          );
          this.error = err.message;
        }
      });
  }

  fillBilling() {
    this.payment.address_line1 = this.application.address.line1;
    this.payment.address_line2 = this.application.address.line2;
    this.payment.address_city = this.application.address.city;
    this.payment.address_state = this.application.address.state;
    this.payment.address_zip = this.application.address.zip;
  }
}



// WEBPACK FOOTER //
// ./client/components/modal/modal.controller.js